<template>
  <v-container fluid>
    <InputSearch
      class="mt-3 mb-3"
      @clickAdvancedSearch="showSearch = true"
      @clickSearch="onSearch"
      :search="search"
      :placeholder="'ชื่อผู้ใช้งาน'"
      :agentGroup="agentGroup"
      showGroupSearch
    />

    <!-- <div style="display: flex;">
      <v-flex
        xs12
        sm12
        class="form-control"
        style="width: 35%;"
      >
        <div class="fs-16 bold6 color-darkGrey" style="white-space: nowrap">กลุ่ม</div>
        <multiselect
      
          v-model="search.group"
          :options="agentGroup"
          track-by="groupname"
          label="groupname"
          name="group"
          :searchable="true"
          selectLabel
          selectedLabel
          deselect-label
          @input="onSearch"
        ></multiselect>
      </v-flex>
  
      <div style="display: flex;align-items: end;width: 65%;">
      <InputSearch
        @clickAdvancedSearch="showSearch = true"
        @clickSearch="onSearch"
        @clearSearch="clearSearch"
        :search="search"
        :placeholder="'ค้นหา รหัสสมาชิก, ชื่อ - นามสกุล, อีเมล, เบอร์, สถาบัน'"
      />
    </div>
    </div> -->

    <!-- <h1 class="headline mt-2 mb-2">Admin/Agent User Management</h1>

    <v-layout wrap>
      <v-flex xs12 :sm6="selectedGroup" class="pa-1">
        <v-layout class="mb-2">
          <v-flex>
            <h2 class="title grey--text mt-2">Group</h2>
          </v-flex>
          <add-admin-group @addGroup="addGroup"></add-admin-group>
        </v-layout>

        <template v-if="groups && groups.length > 0">
          <v-card>
            <template v-for="(group, gindex) in groups">
              <div class="pa-3" :key="`group_${group.id}`">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-bold">
                      {{ group.groupname }}
                    </div>
                    <div class="caption">
                      {{ group.groupdescription ? group.groupdescription : '&nbsp;' }}
                    </div>
                  </v-flex>
                  <edit-admin-group
                    v-model="groups[gindex]"
                    @editGroup="editGroup"
                    :key="'group_' + group.id + '_' + gindex"
                  ></edit-admin-group>

                  <v-btn
                    fab
                    small
                    color="primary"
                    outline
                    class="mx-1 my-0"
                    @click="onDeleteGroup(group)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>

                  <v-icon class="mt-2 ml-2" style="cursor: pointer" @click="selectedGroup = group">
                    arrow_forward_ios
                  </v-icon>
                </v-layout>
              </div>
              <v-divider :key="`group_divider_${group.id}`" v-if="groups.length - 1 != gindex" />
            </template>
          </v-card>
        </template>
        <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
          No data available
        </div>
      </v-flex>
      <v-flex xs12 :sm6="selectedGroup" class="pa-1" v-if="selectedGroup">
        <v-layout class="mb-2">
          <v-flex>
            <h2 class="title grey--text mt-2">{{ selectedGroup.groupname }} Group</h2>
          </v-flex>
          <add-admin-sub-group
            :group="selectedGroup"
            @addSubGroup="addSubGroup"
          ></add-admin-sub-group>
        </v-layout>

        <template v-if="filterSubGroups && filterSubGroups.length > 0">
          <v-card>
            <template v-for="(subgroup, gindex) in filterSubGroups">
              <div class="pa-3" :key="`group_${subgroup.id}`">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-bold">
                      {{ subgroup.subgroupname }}
                    </div>
                    <div class="caption">
                      {{ subgroup.subgroupdescription ? subgroup.subgroupdescription : '&nbsp;' }}
                    </div>
                  </v-flex>
                  <edit-admin-sub-group
                    :group="selectedGroup"
                    v-model="filterSubGroups[gindex]"
                    @editSubGroup="editSubGroup"
                  ></edit-admin-sub-group>

                  <v-btn
                    fab
                    small
                    color="primary"
                    outline
                    class="mx-1 my-0"
                    @click="onDeleteSubGroup(subgroup)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                </v-layout>
              </div>
              <v-divider
                :key="`group_divider_${subgroup.id}`"
                v-if="filterSubGroups.length - 1 != gindex"
              />
            </template>
          </v-card>
        </template>
        <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
          No data available
        </div>
      </v-flex>
    </v-layout> -->

    <div class="pa-1">
      <v-layout class="mb-2" style="display: flex; align-items: center">
        <v-flex>
          <!-- <h2 class="title grey--text mt-2">สมาชิกแอดมิน</h2> -->
          <!-- <div class="headline primary--text bold7 fs-24">สมาชิกแอดมิน</div> -->
          <Typography h2 bold label="สมาชิกแอดมิน" />
        </v-flex>
        <v-btn
          variant="outlined"
          icon
          :color="'#BECCDB'"
          :loading="allusersloading"
          style="border-radius: 50% !important"
          @click="showUserModalAdd = true"
        >
          <img :src="`/static/img/Add.png`" alt class="responsive-img" style="height: 14px" />
        </v-btn>
      </v-layout>
      <v-layout class="my-5" justify-center v-if="allusersloading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table
          :loading="allusersloading"
          :headers="headers"
          :items="admins"
          class="elevation-1"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.name }}</td>
            <!-- <td>
            <template v-if="props.item.type == 'admin'">
              <change-password :userid="props.item.adminid"></change-password>
            </template>
          </td>
          <td>{{ getRole(props.item.privilege) || '-' }}</td> -->
            <td>{{ props.item.groupname || '-' }}</td>
            <!-- <td>{{ props.item.subgroupname || '-' }}</td> -->
            <td>
              <TooltipTable
                :datas="props"
                @modalEdit="showEdit(props), (showUserModalEdit = true)"
                @Delete="onDeleteUser(props.item)"
                showDelete
                :showChangePassword="groupname === 'Depa Super Admin' ? true : false"
                @modalChangePassword="
                  showEdit(props.item), (modalChangePassword = true)
                  user = {
                    password: null,
                    confirmpassword: null
                  }
                "
              ></TooltipTable>

              <!-- <template v-if="!loadingAgentSubGroup">
                <edit-user
                  :key="props.index + '_' + props.item.adminid"
                  v-model="props.item"
                  :projectdata="projectdata"
                  :agencyOptions="agencyOptions"
                  @editUser="onEditUser"
                ></edit-user>
              </template>
              <v-btn
                fab
                small
                outline
                color="primary"
                @click="onDeleteUser(props.item)"
                ><v-icon>delete</v-icon></v-btn
              > -->

              <!-- <toggle-button
              :value="props.item.assign_status"
              :sync="true"
              @change="
                putassignstatusByadminid(props.item.adminid, props.item.assign_status)
                props.item.assign_status = !props.item.assign_status
              "
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
            /> -->
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-dialog persistent v-model="showUserModalAdd" max-width="500">
      <add-user
        v-if="showUserModalAdd"
        :projectdata="projectdata"
        :agencyOptions="agencyOptions"
        @addUser="onAddUser"
        @closemodal="showUserModalAdd = false"
      ></add-user>
    </v-dialog>

    <v-dialog persistent v-model="showUserModalEdit" max-width="500">
      <!-- <edit-admin-group
        v-model="groups[showEditItem.index]"
        @editGroup="editGroup"
        :key="showEditItem.index"
        @closemodal="showUserModalEdit = false"
      ></edit-admin-group> -->
      <edit-user
        v-if="showUserModalEdit"
        :key="showEditItem.index"
        v-model="showEditItem.item"
        :projectdata="projectdata"
        :agencyOptions="agencyOptions"
        @editUser="onEditUser"
        @closemodal="showUserModalEdit = false"
      ></edit-user>
    </v-dialog>

    <v-dialog persistent v-model="modalChangePassword" max-width="500">
      <div class="pa-4">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <Typography h2 bold :label="$t('เปลี่ยนรหัสผ่าน')" />
          <v-btn icon @click="onCancel"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pt-2">
          <div class="pb-3">
            <div style="display: flex">
              <Typography h5 semiBold :label="$t('ชื่อผู้ใช้งาน :')" />
              <Typography class="pl-2" h5 medium :label="showEditItem.adminid" />
            </div>
            <div style="display: flex">
              <Typography h5 semiBold :label="$t('กลุ่ม :')" />
              <Typography class="pl-2" h5 medium :label="showEditItem.groupname" />
            </div>
          </div>
          <v-flex
            xs12
            sm12
            class="form-control px-1"
            :class="{ 'has-error': errors.has('password') }"
          >
            <Typography h5 semiBold label="รหัสผ่าน" />
            <input
              type="password"
              :placeholder="'รหัสผ่าน'"
              v-model="user.password"
              class="form-control"
              maxlength="255"
              ref="password"
              name="password"
              v-validate="'required'"
            />
            <p class="text-error" v-if="errors.has('password')">{{ errors.first('password') }}</p>
          </v-flex>
          <v-flex
            xs12
            sm12
            class="form-control px-1"
            :class="{ 'has-error': errors.has('confirmpassword') }"
          >
            <Typography h5 semiBold label="ยืนยันรหัสผ่าน" />
            <input
              type="password"
              :placeholder="'ยืนยันรหัสผ่าน'"
              v-model="user.confirmpassword"
              class="form-control"
              name="confirmpassword"
              v-validate="'required|confirmed:password'"
            />
            <p class="text-error" v-if="errors.has('confirmpassword')">
              {{ errors.first('confirmpassword') }}
            </p>
          </v-flex>

          <div class="pt-3" style="display: flex; justify-content: center">
            <Button outline :loading="loadingUser" :label="$t('cancel')" @click="onCancel" />
            <Button
              depressed
              :loading="loadingUser"
              :label="$t('Save')"
              @click="onChangePassword"
            />
          </div>
        </div>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
const AddAdminGroup = () => import('./AddAdminGroup')
const EditAdminGroup = () => import('./EditAdminGroup')
const AddAdminSubGroup = () => import('./AddAdminSubGroup')
const EditAdminSubGroup = () => import('./EditAdminSubGroup')
const ChangePassword = () => import('./ChangePassword')
const AddUser = () => import('./AddUser')
const EditUser = () => import('./EditUser')
import { ToggleButton } from 'vue-js-toggle-button'
import InputSearch from '@/components/elements/InputSearch.vue'
import { parse } from 'date-fns'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'

export default {
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agentGroup: 'getAgentGroup'
    })
    // filterSubGroups() {
    //   if (this.selectedGroup) {
    //     return this.subgroups.filter(el => {
    //       return el.admingroupid == this.selectedGroup.id
    //     })
    //   }
    //   return []
    // }
  },
  components: {
    AddAdminGroup,
    EditAdminGroup,
    AddAdminSubGroup,
    EditAdminSubGroup,
    ChangePassword,
    AddUser,
    EditUser,
    ToggleButton,
    InputSearch,
    TooltipTable,
    Typography,
    Button
  },
  data() {
    return {
      showTooltip: false,
      projectdata: null,
      agencyOptions: [],
      allusersloading: false,
      showUserModalAdd: false,
      showUserModalEdit: false,
      modalChangePassword: false,
      showEditItem: {},
      showSearch: false,
      user: {
        password: null,
        confirmpassword: null
      },
      search: {
        nameAll: '',
        group: ''
      },
      adminloading: [],
      admins: [],
      groups: [],
      subgroups: [],
      pagination: {
        rowsPerPage: 999
      },
      headers: [
        { text: 'No.', value: 'index', sortable: false },
        { text: 'ชื่อผู้ใช้งาน', sortable: false },
        { text: 'กลุ่ม', sortable: false },
        { text: '', sortable: false }
      ],
      selectedGroup: null,
      groupname: ''
    }
  },
  async mounted() {
    this.allusersloading = true
    this.groupname = this.$localStorage.get('groupname')
    await this.getAdmins()
    await this.getProject()
    await this.getAgencyData()
    this.allusersloading = false
  },
  methods: {
    async onSearch() {
      this.allusersloading = true
      await this.getAdmins()
      this.allusersloading = false
    },
    showEdit(props) {
      this.showEditItem = props
    },
    getProject() {
      return new Promise(resolve => {
        api.getdepaproject({}, (err, response) => {
          this.projectdata = response.data
          resolve()
        })
      })
    },
    getAgencyData() {
      return new Promise(resolve => {
        api.getDepaAgencyMaster({ pageid: this.selectedBot.pageid }, (err, response) => {
          this.agencyOptions = response.data
          resolve()
        })
      })
    },
    // getAgencyData() {
    //   var data = {
    //     pageid: this.selectedBot.pageid
    //   }

    //   api.getDepaAgencyMaster(data, (err, response) => {
    //     this.agencyOptions = response.data
    //   })
    // },
    // getRole(privilege) {
    //   try {
    //     var parsed_privilege = JSON.parse(privilege)
    //     if (parsed_privilege.role == 'agency') {
    //       return 'หน่วยร่วม'
    //     } else if (parsed_privilege.role == 'admin') {
    //       return 'Admin'
    //     } else if (parsed_privilege.role == 'superadmin') {
    //       return 'Super admin'
    //     } else return ''
    //   } catch (error) {
    //     return ''
    //   }
    // },
    putassignstatusByadminid(adminid, status) {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        assign_status: !status,
        adminid: adminid
      }
      this.adminloading.push(adminid)
      api.putassignstatusByadminid(data, (err, response) => {
        if (response.responsecode == 200) {
          var index = vm.adminloading.findIndex(el => el == adminid)
          vm.adminloading.splice(index, 1)
          status = !status
        }
      })
    },
    async onAddUser(user) {
      this.$store.dispatch('loadAgents')
      await this.getAdmins()
      // var responseAdmin = await this.getAdmins()
      // if (responseAdmin.data) {
      //   this.admins = responseAdmin.data
      // }
      // this.$swal.fire({
      //   type: 'success',
      //   text: 'เพิ่มแอดมินสำเร็จ',
      // })
    },
    async onEditUser(user) {
      // this.$store.dispatch('loadAgents')
      await this.getAdmins()
      // var responseAdmin = await this.getAdmins()
      // if (responseAdmin.data) {
      //   this.admins = responseAdmin.data
      // }
    },
    getAdmins() {
      return new Promise((resolve, reject) => {
        var search = {}
        for (const [key, value] of Object.entries(this.search)) {
          if (key === 'group' && typeof value) {
            if (value) {
              Object.assign(search, { ['group']: value ? value.id : '' })
            }
          } else if (value) {
            Object.assign(search, { [key]: value })
          }
        }

        api.getAdmins(
          {
            pageid: this.selectedBot.pageid,
            // group: this.search.group ?  this.search.group.id : '',
            // nameAll: this.search.nameAll,
            ...search
          },
          (err, response) => {
            this.admins = response.data
            resolve()
          }
        )
      })
    },
    // getAdminGroup() {
    //   var data = {
    //     pageid: this.selectedBot.pageid,
    //   }
    //   return new Promise((resolve, reject) => {
    //     api.getAdminGroup(data, (error, response) => {
    //       if (error) {
    //         console.error(error)
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    // getAdminSubGroup() {
    //   var data = {
    //     pageid: this.selectedBot.pageid,
    //   }
    //   return new Promise((resolve, reject) => {
    //     api.getAdminSubGroup(data, (error, response) => {
    //       if (error) {
    //         console.error(error)
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    addGroup(payload) {
      this.groups.push(payload)
      this.$store.dispatch('loadAgentGroups')
    },
    editGroup(payload) {
      var index = this.groups.findIndex(el => {
        return el.id == payload.id
      })
      if (index != -1) {
        this.$set(this.groups, index, payload)
      }
      this.$store.dispatch('loadAgentGroups')
    },
    // async onDeleteGroup(group) {
    //   var result = await this.$swal.fire({
    //     title: this.$t('Do you want to delete {name}?', {
    //       name: group.groupname.replace(/\<|\>/g, ''),
    //     }),
    //     type: 'warning',
    //     confirmButtonText: this.$t('Confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     reverseButtons: true,
    //     showCancelButton: true,
    //   })
    //   if (result.value) {
    //     await this.deleteGroup(group)
    //     var index = this.groups.findIndex((el) => {
    //       return el.id == group.id
    //     })
    //     if (index != -1) {
    //       this.groups.splice(index, 1)
    //       this.$store.dispatch('loadAgentGroups')
    //     }
    //   }
    // },
    // deleteGroup(data) {
    //   return new Promise((resolve, reject) => {
    //     var request = {
    //       id: data.id,
    //       pageid: this.selectedBot.pageid,
    //     }
    //     api.deleteadmingroup(request, function (error, response) {
    //       if (error) {
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    // addSubGroup(payload) {
    //   this.subgroups.push(payload)
    //   this.$store.dispatch('loadAgentSubGroups')
    // },
    // editSubGroup(payload) {
    //   var index = this.subgroups.findIndex((el) => {
    //     return el.id == payload.id
    //   })
    //   if (index != -1) {
    //     this.$set(this.subgroups, index, payload)
    //   }
    //   this.$store.dispatch('loadAgentSubGroups')
    // },
    // async onDeleteSubGroup(group) {
    //   var result = await this.$swal.fire({
    //     title: this.$t('Do you want to delete {name}?', {
    //       name: group.subgroupname.replace(/\<|\>/g, ''),
    //     }),
    //     type: 'warning',
    //     confirmButtonText: this.$t('Confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     reverseButtons: true,
    //     showCancelButton: true,
    //   })
    //   if (result.value) {
    //     await this.deleteSubGroup(group)
    //     var index = this.subgroups.findIndex((el) => {
    //       return el.id == group.id
    //     })
    //     if (index != -1) {
    //       this.subgroups.splice(index, 1)
    //       this.$store.dispatch('loadAgentSubGroups')
    //     }
    //   }
    // },
    // deleteSubGroup(data) {
    //   return new Promise((resolve, reject) => {
    //     var request = {
    //       id: data.id,
    //       pageid: this.selectedBot.pageid,
    //     }
    //     api.deleteadminsubgroup(request, function (error, response) {
    //       if (error) {
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    async onDeleteUser(user) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          name: user.name.replace(/\<|\>/g, '')
        }),
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true
      })
      if (result.value) {
        this.$store.dispatch('loading')
        await this.deleteadminusers({ userid: user.adminid })
        if (this.$store.state.userid == user.adminid) {
          this.$store.dispatch('logout', null).then()
          if (this.user.type == 'admin') {
            this.$router.push('/' + this.currentLang + '/nigol')
          } else {
            this.$router.push('/' + this.currentLang + '/login')
          }
        }
        await this.getAdmins()
        this.$store.dispatch('loading')
      }
    },
    deleteadminusers(data) {
      return new Promise((resolve, reject) => {
        var request = {
          userid: data.userid,
          pageid: this.selectedBot.pageid
        }
        api.deleteadminusers(request, function(error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },

    async onChangePassword() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }

      this.$swal
        .fire({
          type: 'question',
          title: '<div class="headline primary--text bold7 fs-24">ยืนยันการเปลี่ยนรหัสผ่าน</div>',
          showCancelButton: true,
          showCloseButton: true
        })
        .then(result => {
          if (result.value) {
            var data = {
              userid: this.showEditItem.adminid,
              pageid: this.selectedBot.pageid,
              password: this.user.confirmpassword
            }
            return new Promise((resolve, reject) => {
              api.changeticketpasswordadminuser({ data: data }, (error, response) => {
                if (error) {
                  reject(error)
                  this.$swal.fire({
                    type: 'error',
                    title:
                      '<div class="headline primary--text bold7 fs-24">เปลี่ยนรหัสผ่านไม่สำเร็จ</div>',
                    confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
                  })
                } else {
                  resolve(response)
                  this.modalChangePassword = false
                  this.$swal
                    .fire({
                      type: 'success',
                      title:
                        '<div class="headline primary--text bold7 fs-24">เปลี่ยนรหัสผ่านสำเร็จ</div>',
                      confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
                    })
                    .then(result => {
                      if (result.value) {
                        if (this.showEditItem.adminid == this.$store.state.userid) {
                          this.$swal
                            .fire({
                              text: 'เข้าสู่ระบบใหม่อีกครั้งเพื่อเปลี่ยนแปลงข้อมูล'
                            })
                            .then(async () => {
                              await this.$store.dispatch('logout')
                              var isFacebook = this.$store.state.isFacebook
                              if (
                                this.$router.history.current.name != 'login' ||
                                this.$router.history.current.name != 'nigol'
                              ) {
                                if (isFacebook) {
                                  this.$router.push('/login')
                                } else {
                                  this.$router.push('/nigol')
                                }
                              }
                            })
                        }
                      }
                    })
                }
              })
            })
          }
        })
    },
    onCancel() {
      this.modalChangePassword = false
      this.user = {
        password: null,
        confirmpassword: null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Users.vue